import UIManager from '../UIManager';
var NativeModules = {
  UIManager: UIManager
};
export default NativeModules;